import { FC, createElement } from 'react'
import { cn } from '../utils/cn'

import type { CreateComponentsUnion } from '../types'

// NOTE: We can't use string interpolation or template literals
// tailwind doesn't understand what className to include into bundle on runtime
const STACK_GAPS = {
  0: 'gap-y-0',
  px: 'gap-y-px',
  '0.5': 'gap-y-0.5',
  1: 'gap-y-1',
  1.5: 'gap-y-1.5',
  2: 'gap-y-2',
  2.5: 'gap-y-2.5',
  3: 'gap-y-3',
  '3.5': 'gap-y-3.5',
  4: 'gap-y-4',
  5: 'gap-y-5',
  6: 'gap-y-6',
  7: 'gap-y-7',
  8: 'gap-y-8',
  9: 'gap-y-9',
  10: 'gap-y-10',
  11: 'gap-y-11',
  12: 'gap-y-12',
  14: 'gap-y-14',
  16: 'gap-y-16'
}

type StackGap = keyof typeof STACK_GAPS

type StackElementType =
  | 'div'
  | 'section'
  | 'article'
  | 'ul'
  | 'ol'
  | 'li'
  | 'nav'
  | 'header'
  | 'footer'
  | 'main'
  | 'form'

type StackProps = CreateComponentsUnion<StackElementType, { gap: StackGap }>

export const Stack: FC<StackProps> = ({
  as = 'div',
  gap = 6,
  className,
  children,
  ...props
}) => {
  const stackClassName = cn(
    'grid-col-1 relative grid min-h-0 w-full min-w-0',
    '[&>*]:min-w-0 [&>*]:max-w-full',
    STACK_GAPS[gap],
    className
  )
  return createElement(
    as,
    {
      ...props,
      className: stackClassName
    },
    children
  )
}
